import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewMedicalRecords extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_medical_records_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Medical Record Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                        <div className="m-portlet m-portlet--success m-portlet--head-solid-bg m-portlet--full-height ">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <h3 className="m-portlet__head-text">Pet Information</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="m-portlet__body">
                                <div className="m-widget4">
                                    <div className="col-md-12">
                                        <div className="row m--align-center">
                                            <div className="m-widget4__img m-widget4__img--pic my-0 user-avatar mx-auto">
                                                <img src="https://s3.amazonaws.com/uploads.development.petpos/uploads/4/medical-records/avatar/1539940222832_116204.jpg" alt=""/>
                                            </div>
                                        </div>
                                    <div className="row">
                                        <div className="m-widget4__info mx-auto my-0 mt-2">
                                            <span className="m-widget4__title">boxer</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <span className="m-badge m-badge--info mx-auto my-0 px-2"><strong>Id: </strong>1121</span>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-12 m--align-center">
                                            <span className="m-badge m-badge--danger m-badge--dot"></span>
                                            <span className="m--font-danger"> Sold</span>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row mt-4">
                                            <div className="col-md-6">
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-calendar-alt mr-2"></i>
                                                    <span>
                                                    <strong>Arrival Date: </strong>
                                                    </span>2018-10-17</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-paw mr-2"></i>
                                                    <span><strong>Type of Animal: </strong></span>Dog</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-paint-brush mr-2"></i>
                                                    <span>
                                                    <strong>Color Markings: </strong>
                                                    </span>black</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-microchip mr-2"></i>
                                                    <span><strong>Microchip: </strong></span>4566</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-genderless mr-2"></i>
                                                    <span><strong>Gender: </strong></span>male</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-mars mr-2"></i>
                                                    <span><strong>Sire: </strong></span>dad</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-mars mr-2"></i><span><strong>Dam: </strong>
                                                    </span>mom</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-bars mr-2"></i>
                                                    <span><strong>Registration Type: </strong>
                                                    </span>Reg type 1</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-id-card mr-2"></i>
                                                        <span><strong>Pet Id: </strong>
                                                        </span>1121
                                                        <span className="ml-2">
                                                        <i className="m-form__heading-help-icon flaticon-info"></i>
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-venus-mars mr-2"></i>
                                                    <span><strong>Breed: </strong></span>boxer</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-birthday-cake mr-2"></i>
                                                    <span><strong>Date of Birth: </strong></span>2018-08-07</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-times-circle mr-2"></i><span>
                                                    <strong>Cross Breed: </strong></span>no</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-weight mr-2"></i>
                                                    <span><strong>Weight: </strong></span>
                                                    <span>20 Lb</span></span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-ban mr-2"></i><span>
                                                    <strong>Sire Number: </strong></span>213</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-ban mr-2"></i>
                                                    <span><strong>Dam Number: </strong></span>56345</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-6">
                            <div className="m-portlet m-portlet--full-height">
                                <div className="m-portlet m-portlet--success m-portlet--head-solid-bg" style={{boxShadow: 'none'}}>
                                    <div className="m-portlet__head">
                                        <div className="m-portlet__head-caption">
                                            <div className="m-portlet__head-title">
                                                <h3 className="m-portlet__head-text">Breeder Information</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="m-portlet__body">
                                        <div className="m-widget4">
                                            <div className="m-widget4__item">
                                                <span className="m-widget4__sub">
                                                    <i className="fas fa-id-card mr-2"></i>
                                                <span>
                                                    <strong>Breeder: </strong>
                                                </span>breeder name</span>
                                            </div>
                                            <div className="m-widget4__item">
                                                <span className="m-widget4__sub">
                                                    <i className="fas fa-genderless mr-2"></i>
                                                <span>
                                                    <strong>USDA Number: </strong>
                                                </span>43534</span>
                                            </div>
                                            <div className="m-widget4__item">
                                                <span className="m-widget4__sub">
                                                <i className="fas fa-paw mr-2"></i><span>
                                                <strong>Breeder's Address: </strong>
                                                </span>220, Diggala Rd, Keselwatta</span>
                                            </div>
                                            <div className="m-widget4__item">
                                                <span className="m-widget4__sub">
                                                <i className="fas fa-birthday-cake mr-2"></i><span>
                                                <strong>Breeder's Phone: </strong>
                                                </span>+0772000919</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-6">
                            <div className="m-portlet m-portlet--success m-portlet--head-solid-bg" style={{boxShadow: 'none'}}>
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <h3 className="m-portlet__head-text">Vaccinations</h3>
                                    </div>
                                    </div>
                                </div>
                                <div className="m-portlet__body">
                                    <div className="m-accordion m-accordion--default" id="m_accordion_4" role="tablist">
                                        <div className="m-accordion__item overlay-visible">
                                            <div className="m-accordion__item-head collapsed" role="tab" id="m_accordion_4_item_0_head" data-toggle="collapse" href="#m_accordion_4_item_0_body" aria-expanded="false">
                                                <span className="m-accordion__item-icon">
                                                    <i className="fas fa-syringe"></i>
                                                </span>
                                                <span className="m-accordion__item-title">Vaccination 1 - admin 1</span>
                                                <span className="m-accordion__item-mode"></span>
                                                
                                            </div>
                                            <div className="m-accordion__item-body collapse" id="m_accordion_4_item_0_body" role="tabpanel" aria-labelledby="m_accordion_4_item_0_head" data-parent="#m_accordion_4">
                                                <div className="m-accordion__item-content">
                                                    <div className="m-widget4">
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                            <i className="fas fa-calendar-alt mr-2"></i><span><strong>Date: </strong></span>2018-10-17</span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                            <i className="fas fa-clipboard-check mr-2"></i><span><strong>Administered: </strong></span>admin 1</span>
                                                        </div>
                                                        <div className="m-widget4__item"><span className="m-widget4__sub"><i className="fas fa-info-circle mr-2"></i><span>
                                                            <strong>More Info: </strong></span>vacc 1</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewMedicalRecords));